<template>
  <view-toolbox
    title="Event Details Item Properties"
    back-title="Event Details"
    :back-count="8"
  >
    <DetailProperties
      :item="item"
    />
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import ViewUtils from '@/components/views/ViewUtils';
import DetailProperties from '@/components/views/shared/DetailProperties';

export default {
  name: 'CalendarEventDetailProperties',
  components: {
    ViewToolbox,
    DetailProperties,
  },
  mixins: [
    ViewUtils,
  ],
  computed: {
    item() {
      const {
        columnIndex,
        groupIndex,
        itemIndex,
        layoutIndex,
      } = this.$route.params;

      const item = this
        .viewRaw
        ?.details
        ?.columns[layoutIndex]
        ?.groups[groupIndex]
        ?.columns[columnIndex][itemIndex];

      return item || {};
    },
  },
};
</script>

<style lang="scss">
</style>
